import { Module } from 'vuex';
import {
  IVersionListStoreState,
  IVuexRootStoreState,
} from '@/types';
import { VersionListStoreGetters } from './getters';
import { VersionListStoreActions } from './actions';
import { VersionListStoreMutations } from './mutations';
import { getDefaultState } from './state';

export const VersionListStore: Module<IVersionListStoreState, IVuexRootStoreState> = {
  namespaced: true,
  state: getDefaultState(),
  getters: VersionListStoreGetters,
  actions: VersionListStoreActions,
  mutations: VersionListStoreMutations,
};
